import { MediaAssetOrientation } from '@calm/evexia-web-sdk';
import { MediaTrackerFn } from '@rhg/hooks/use-media-tracker/types';
import { SxProps, Theme } from '@rhg/libs/material';
import { ReactElement } from 'react';
import { MediaEl, PlayerVideo } from '../types';

export enum VideoPlayerControls {
    None = 'none',
    Minimal = 'minimal',
    Full = 'full',
}

export type ControlButtonType = 'play' | 'pause' | 'mute' | 'unmute' | 'stop';

export interface VideoPlayerProps {
    videos: PlayerVideo[];
    forcedOrientation?: MediaAssetOrientation;
    autoplay?: boolean;
    shouldInterruptPlay?: boolean;
    muted?: boolean;
    showLoading?: boolean;
    showPoster?: boolean;
    showPosterOnEnd?: boolean;
    controls?: VideoPlayerControls;
    title?: string;
    subtitle?: string;
    hasAutoplayFocusTrap?: boolean;
    sx?: SxProps<Theme>;
    videoJsSx?: SxProps<Theme>;
    trackFn?: MediaTrackerFn;
    willTrackProgress?: boolean;
    previousProgress?: number;
    actionButton?: ReactElement;
    loop?: boolean;
    onEnd?: (player: HTMLVideoElement) => void;
    onControlClick?: (buttonType: ControlButtonType) => void;
    /**
     * Fires whenever the underlying media element changes (e.g. once HLS.js/video.js
     * finishes mounting it), letting a caller drive playback imperatively without
     * rendering any of the built-in `controls` UI.
     */
    onMediaElChange?: (mediaEl: MediaEl) => void;
}
